import { render, staticRenderFns } from "./externalphotofindings.vue?vue&type=template&id=297d774e&scoped=true&"
import script from "./externalphotofindings.vue?vue&type=script&lang=js&"
export * from "./externalphotofindings.vue?vue&type=script&lang=js&"
import style0 from "./externalphotofindings.vue?vue&type=style&index=0&id=297d774e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d774e",
  null
  
)

export default component.exports